import { render, staticRenderFns } from "./TenderCommercialDocumentAndOffer.vue?vue&type=template&id=52a76051&scoped=true"
import script from "./TenderCommercialDocumentAndOffer.vue?vue&type=script&lang=js"
export * from "./TenderCommercialDocumentAndOffer.vue?vue&type=script&lang=js"
import style0 from "./TenderCommercialDocumentAndOffer.vue?vue&type=style&index=0&id=52a76051&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a76051",
  null
  
)

export default component.exports